// G360_K470 - sort, filter, column choice and CSV export (the shared DataTable).
// G360_K462 - a failed read is said, not shown as an empty list or a zero; a refused change is said, not shown as done.
// Global detectors - the platform-wide detector library pushed to tenants.
import { useEffect, useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import { listDetectorCatalog } from '../lib/adminApi.js';
import { EmptyState } from '@govern360/shared/components/ui.jsx';
import { DataTable } from '@govern360/shared/components/datatable.jsx';

const SEV_RANK = { critical: 4, high: 3, medium: 2, low: 1, info: 0 };
const COLS = [
  { key: 'name', label: 'Detector', render: (d) => <strong>{d.name}</strong> },
  { key: 'category', label: 'Category', render: (d) => <span className="pill p-gray">{d.category}</span> },
  { key: 'default_action', label: 'Default action', render: (d) => <span className={`pill ${d.default_action === 'block' ? 'p-dang' : d.default_action === 'redact' ? 'p-warn' : 'p-info'}`}>{d.default_action}</span> },
  { key: 'severity', label: 'Severity', sort: (d) => (d.severity == null ? null : (SEV_RANK[String(d.severity).toLowerCase()] ?? -1)) },
  { key: 'tier', label: 'Tier', render: (d) => <span style={{ color: 'var(--g-text-2)', fontSize: 12 }}>{d.tier}</span> },
];

export default function DetectorsPage() {
  const [dets, setDets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadErr, setLoadErr] = useState('');
  useEffect(() => { listDetectorCatalog().then(({ data, error }) => { setLoadErr(error ? (error.message || 'the read failed') : ''); setDets(data); setLoading(false); }); }, []);

  return (
    <div>
      <div className="ph"><div><h1 className="ph-h1">Global detectors</h1><p className="ph-sub">The platform-wide detector library available to every tenant.</p></div></div>
      {loading ? (
        <div className="card" style={{ textAlign: 'center', padding: 48, color: 'var(--g-text-2)' }}>Loading&hellip;</div>
      ) : loadErr ? (
        <div className="card g360-admin-err" style={{ padding: 24, borderLeft: '3px solid var(--g-danger)' }}>
          <p style={{ color: 'var(--g-danger)', fontSize: 14, margin: '0 0 8px' }}>The detector catalog could not be read</p>
          <p style={{ fontSize: 13, color: 'var(--g-text-2)', margin: 0 }}>{loadErr}. This is not the same as there being none.</p>
        </div>
      ) : dets.length === 0 ? (
        <EmptyState icon={ShieldCheck} title="No detectors in catalog" hint="Run migration 0006 to seed the detector catalog." />
      ) : (
        <DataTable rows={dets} columns={COLS} storageKey="g360.admin.detectors.hiddenCols" name="detector-catalog"
          placeholder="Filter detectors..." rowKey={(d) => d.id} />
      )}
    </div>
  );
}
